import { useEffect, useState } from "react";
import api, { formatCNPJ } from "@/lib/api";
import { Building2, Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", cnpj: "", contact_email: "", phone: "", plan: "corporativo", lives: 0 };

export default function GestorEmpresas() {
  const [companies, setCompanies] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/companies").then(r=>setCompanies(r.data));
  useEffect(()=>{ load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/companies", { ...form, lives: parseInt(form.lives || 0) });
      toast.success("Empresa cadastrada!");
      setForm(empty); setShowForm(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Remover empresa?")) return;
    await api.delete(`/companies/${id}`);
    toast.success("Removido");
    load();
  };

  const totalVidas = companies.reduce((s,c)=>s+(c.lives||0),0);

  return (
    <div className="space-y-6" data-testid="gestor-empresas-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-black text-[#0E2A5C] flex items-center gap-2"><Building2 className="h-7 w-7" /> Empresas (B2B)</h1>
          <p className="text-sm text-slate-500">{companies.length} empresa(s) • {totalVidas} vidas vinculadas</p>
        </div>
        <button onClick={()=>setShowForm(s=>!s)} className="btn-primary text-sm" data-testid="add-company-button">
          {showForm ? <><X className="h-4 w-4" /> Fechar</> : <><Plus className="h-4 w-4" /> Nova empresa</>}
        </button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="card-soft p-6 grid sm:grid-cols-2 gap-3" data-testid="company-form">
          <input required placeholder="Razão social" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-name" />
          <input required placeholder="CNPJ" value={formatCNPJ(form.cnpj)} onChange={(e)=>setForm({...form, cnpj: e.target.value.replace(/\D/g,"")})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-cnpj" />
          <input required type="email" placeholder="E-mail de contato" value={form.contact_email} onChange={(e)=>setForm({...form, contact_email: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-email" />
          <input placeholder="Telefone" value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-phone" />
          <input type="number" placeholder="Vidas" value={form.lives} onChange={(e)=>setForm({...form, lives: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-lives" />
          <select value={form.plan} onChange={(e)=>setForm({...form, plan: e.target.value})} className="px-3 py-2.5 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0]" data-testid="company-plan">
            <option value="corporativo">Corporativo</option><option value="gold">Gold</option><option value="diamante">Diamante</option>
          </select>
          <button type="submit" className="btn-primary sm:col-span-2" data-testid="company-submit">Cadastrar</button>
        </form>
      )}

      <div className="card-soft overflow-hidden">
        <table className="w-full text-sm" data-testid="companies-table">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Razão social</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">CNPJ</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Vidas</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Plano</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Contato</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {companies.map(c => (
              <tr key={c.id} data-testid={`row-company-${c.id}`}>
                <td className="px-5 py-3 font-semibold text-[#0E2A5C]">{c.name}</td>
                <td className="px-5 py-3 font-mono text-xs">{formatCNPJ(c.cnpj)}</td>
                <td className="px-5 py-3"><span className="font-bold text-[#2A8FE0]">{c.lives}</span></td>
                <td className="px-5 py-3 capitalize">{c.plan}</td>
                <td className="px-5 py-3 text-xs text-slate-600">{c.contact_email}</td>
                <td className="px-5 py-3 text-right">
                  <button onClick={()=>remove(c.id)} className="text-rose-600 hover:text-rose-800" data-testid={`delete-company-${c.id}`}><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
            {companies.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-slate-500">Nenhuma empresa cadastrada.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
